import DentoloReferral from './DentoloReferral';

export default DentoloReferral;
